// src/data/sectionsData.js

const sectionsData = [
    {
        category: "我们的软硬件解决方案",
        items: [
            {
                title: "产品文档整理输出",
                descriptions: [
                    "为企业或项目提供专业的产品文档撰写、整理和最终输出服务。",
                    "包含用户使用手册、技术白皮书、解决方案方案书等多种文档类型。",
                    "根据客户需求定制文档风格，确保文档的可读性与专业度。",
                ],
            },
            {
                title: "单片机开发",
                descriptions: [
                    "从原型验证到生产调试的全流程单片机开发服务。",
                    "熟悉多种主流单片机平台和开发工具，能够快速实现功能需求。",
                    "包括底层驱动开发、通信模块集成、系统功能优化等。",
                ],
            },
            {
                title: "Linux环境下系统开发",
                descriptions: [
                    "Linux 系统平台下的驱动开发、内核裁剪、嵌入式移植等服务。",
                    "可针对定制化需求，进行服务器软件部署与维护。",
                    "为项目提供高效稳定的系统解决方案。",
                ],
            },
            {
                title: "Go Web后端 & 通信协议网关",
                descriptions: [
                    "基于 Go 语言的 Web 后端开发与架构设计，擅长高并发与高可用性。",
                    "协助搭建通信协议网关，实现高效的数据交换与处理。",
                    "精通常用的 Go 框架与库，为客户提供优质的全栈后端支持。",
                ],
            },
            {
                title: "Python Flask后端及桌面应用",
                descriptions: [
                    "基于 Python Flask 框架的后端接口开发与部署。",
                    "桌面端使用 Python 技术栈开发图形化应用程序。",
                    "注重代码的可维护性、可扩展性以及快速迭代能力。",
                ],
            },
            {
                title: "Web前后端 React框架",
                descriptions: [
                    "前端采用 React 框架进行页面交互设计与高效渲染。",
                    "后端可灵活选用 Node.js、Python、Go 等不同技术栈进行配合。",
                    "全栈一体化服务，打造流畅的 Web 应用用户体验。",
                ],
            },
            {
                title: "小程序 (Taro框架 + React)",
                descriptions: [
                    "基于 Taro 框架构建跨端小程序，与 React 生态统一。",
                    "可在微信、支付宝、字节跳动等多平台适配与发布。",
                    "提供从需求分析、UI/UE 设计到上线运维的一站式解决方案。",
                ],
            },
            {
                title: "安卓 / iOS / PC 三端Flutter开发",
                descriptions: [
                    "利用 Flutter 打造跨平台应用，适配 Android、iOS、PC 客户端。",
                    "统一开发代码，快速上线与迭代，减少后期维护成本。",
                    "支持丰富的第三方组件与插件，满足多场景的业务需求。",
                ],
            },
        ],
    },
    {
        category: "我们可研究的解决方案",
        items: [
            {
                title: "AI算法",
                descriptions: [
                    "基础的 AI 算法模型开发与训练，涵盖图像识别、数据挖掘等方向。",
                    "根据客户需求定制算法流程，优化模型性能与资源利用率。",
                    "帮助企业更好地进行数据分析、预测与决策。",
                ],
            },
            {
                title: "蓝牙开发",
                descriptions: [
                    "针对蓝牙设备或应用，进行底层通信协议开发与功能实现。",
                    "熟悉 BLE 相关开发、调试与传输优化。",
                    "助力智能硬件、可穿戴设备的产品快速迭代。",
                ],
            },
            {
                title: "电机驱动开发",
                descriptions: [
                    "电机驱动方面的固件开发与驱动算法优化。",
                    "包括步进电机、直流电机、伺服电机等不同类型控制方案。",
                    "满足工业自动化、智能机器人等多领域项目需求。",
                ],
            },
        ],
    },
    {
        category: "深度感兴趣将会扩展的领域",
        items: [
            {
                title: "机器人",
                descriptions: [
                    "涵盖机器人控制系统、传感与导航算法、机械结构设计等多方面。",
                    "计划研究通用型机器人应用，并提供差异化定制服务。",
                    "助力智能制造、仓储物流、医疗康复等行业。",
                ],
            },
            {
                title: "无人机",
                descriptions: [
                    "专注无人机飞控系统、路径规划、视觉识别等关键技术。",
                    "致力于实现高效自主飞行方案，探索无人机行业更多应用场景。",
                    "农业植保、安防巡检、应急救援等领域的技术落地。",
                ],
            },
            {
                title: "AI智能识别",
                descriptions: [
                    "深入 AI 领域的图像/视频识别、语音识别、自然语言处理等方向。",
                    "打造精确、高效的 AI 识别系统，适配各行各业需求。",
                    "对深度学习的持续研究与算法优化，升级模型效果与性能。",
                ],
            },
        ],
    },
];

export default sectionsData;
